export { WithWideSocialIconsVariation as default } from './WithWideSocialIconsVariation';
